import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { LINKS } from '@/constants/links';
export function Partners() {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["partners"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("info.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("info.text");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="mb-8">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = LINKS();
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = t4.partners;
  let t6;
  if ($[8] !== t) {
    t6 = t("info.cta");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <Button variant="secondary" size="lg" testId="partners" analyticsParam="partners" to={t5}>{t6}</Button>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t7) {
    t8 = <DocumentSection title={t1} isDropdown={false} id="partners">{t3}{t7}</DocumentSection>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}